import _slicedToArray from '../../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js';
import _defineProperty from '../../../node_modules/@babel/runtime/helpers/esm/defineProperty.js';
import { makeStyles, Typography, Box } from '@material-ui/core';
import React__default, { useState, useEffect } from 'react';
import PropTypes__default from 'prop-types';
import CardSlider from '../../widgets/card-slider/CardSlider.js';
import { useBreakpoints } from '../../hooks/useBreakpoints.js';

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles = makeStyles(function (theme) {
  return {
    wrapper: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column"
    },
    header: {
      "max-width": "750px",
      textAlign: "center"
    },
    tileFooter: {
      background: "#DCECF8"
    },
    footerSubtitle: {
      color: theme.palette.secondary[900]
    },
    sliderContainer: {
      width: "1200px"
    },
    infoMessage: _objectSpread({}, theme.typography.infoMessage)
  };
});
var TilesBookings = function TilesBookings(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    description = _ref.description,
    tiles = _ref.tiles,
    backgroundColor = _ref.backgroundColor,
    tileVariant = _ref.tileVariant,
    sliderTitle = _ref.sliderTitle;
  var classes = useStyles();
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    cards = _useState2[0],
    setCards = _useState2[1];
  var _useBreakpoints = useBreakpoints(),
    isLargeScreen = _useBreakpoints.isLargeScreen;
  var sliderOpts = {
    className: "center",
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: isLargeScreen() ? 3 : 1,
    slidesToScroll: 1,
    centerMode: true,
    variableWidth: true
  };
  useEffect(function () {
    if (tiles && classes) {
      // Build cards from tiles
      var items = [];
      var _iterator = _createForOfIteratorHelper(tiles),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _tile$footer, _tile$footer2;
          var tile = _step.value;
          items.push({
            elevation: 0,
            image: tile === null || tile === void 0 ? void 0 : tile.image,
            title: tile === null || tile === void 0 ? void 0 : tile.title,
            subtitle: tile === null || tile === void 0 ? void 0 : tile.subtitle,
            overtitle: tile === null || tile === void 0 ? void 0 : tile.overtitle,
            content: tile === null || tile === void 0 ? void 0 : tile.content,
            variant: tileVariant,
            footerClassName: classes.tileFooter,
            chip: tile === null || tile === void 0 ? void 0 : tile.chip,
            footer: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Typography, {
              className: classes.footerSubtitle,
              variant: "overline"
            }, tile === null || tile === void 0 || (_tile$footer = tile.footer) === null || _tile$footer === void 0 ? void 0 : _tile$footer.subtitle), /*#__PURE__*/React__default.createElement(Typography, {
              variant: "subtitle1",
              component: "div"
            }, tile === null || tile === void 0 || (_tile$footer2 = tile.footer) === null || _tile$footer2 === void 0 ? void 0 : _tile$footer2.title))
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      setCards(items);
    }
  }, [tiles, classes]);
  return /*#__PURE__*/React__default.createElement(Box, {
    style: {
      background: backgroundColor ? backgroundColor : "#FFFFFF"
    },
    className: classes.wrapper,
    mb: 10
  }, /*#__PURE__*/React__default.createElement(Box, {
    px: 2,
    className: classes.header
  }, subtitle && /*#__PURE__*/React__default.createElement(Box, null, /*#__PURE__*/React__default.createElement(Typography, {
    className: classes.infoMessage
  }, subtitle)), title && /*#__PURE__*/React__default.createElement(Box, {
    mt: 2
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h1"
  }, title)), description && /*#__PURE__*/React__default.createElement(Box, {
    mt: 2
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1"
  }, description))), cards && cards.length && /*#__PURE__*/React__default.createElement(Box, {
    mt: 5,
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/React__default.createElement(CardSlider, {
    title: sliderTitle,
    cards: cards,
    sliderOpts: sliderOpts,
    sliderContainerClassName: classes.sliderContainer,
    highlightFocused: true
  })));
};
TilesBookings.propTypes = {
  title: PropTypes__default.string,
  subtitle: PropTypes__default.string,
  description: PropTypes__default.string,
  tiles: PropTypes__default.arrayOf(PropTypes__default.shape({
    title: PropTypes__default.string,
    subtitle: PropTypes__default.string,
    content: PropTypes__default.any,
    variant: PropTypes__default.oneOf(["default", "trial"]),
    image: PropTypes__default.shape({
      url: PropTypes__default.string,
      title: PropTypes__default.string
    }),
    footer: PropTypes__default.shape({
      title: PropTypes__default.string,
      subtitle: PropTypes__default.string
    })
  })),
  tileVariant: PropTypes__default.oneOf(["default", "trial"]),
  backgroundColor: PropTypes__default.string,
  sliderTitle: PropTypes__default.string
};

export { TilesBookings as default };
//# sourceMappingURL=TilesBookings.js.map
